
export class HotGestureTool {
  constructor(viewerApi) {
    this._viewerApi = viewerApi;

    this._names = ["hottouch"];

    this._modifierState = { SHIFT: 0, ALT: 0, CONTROL: 0 };
    this._setMode = null;
    this._saveMode = null;
    this._fovActive = false;
    this._rollActive = false;
    this._startEvent = null;

    this._keys = {
      SHIFT: 16,
      CONTROL: 17,
      ALT: 18,
      ESCAPE: 27,
      LCOMMAND: 91,
      RCOMMAND: 93,
      COMMANDMOZ: 224
    };

    this._ORBIT = "orbit";
    this._ROLL = "worldup";
    this._FOV = "fov";

    this.active = false;
  }
  getNames()
  {
    return this._names;
  }

  getName()
  {
    return this._names[0];
  }

  activate(name)
  {
    this.active = true;
  }

  deactivate(name)
  {
    this.active = false;
  }

  isActive() {
    return this.active;
  }

  __checkStart()
  {
    // Since the start event triggers the tool change we re-send the
    // start event so that the new tool can trigger from it.
    if (this._startEvent)
    {
      this.controller.distributeEvent("handleGesture", this._startEvent);
      this._startEvent = null;
    }
  }

  update()
  {
    if (this.controller.getIsLocked())
    return false;

    var got = this._viewerApi.getActiveNavigationTool();
    var wantRoll = this._fovActive === false && this._rollActive === true;
    var wantFov = this._fovActive === true && this._rollActive === false;

    if (wantRoll || wantFov)
    {
      var want = wantRoll ? this._ROLL : this._FOV;

      if (got === want)
      return false;

      if (got === this._setMode) // We set it we can change it
        {
          this._viewerApi.setActiveNavigationTool(want);
          this._setMode = want;
          this.__checkStart();
          return false;
        }
      this._saveMode = got;
      this._viewerApi.setActiveNavigationTool(want);
      this._setMode = want;
      this.__checkStart();
    } else
    if (this._setMode)
    {
      this._viewerApi.setActiveNavigationTool(this._saveMode);
      this._setMode = null;
      this._saveMode = null;
    }
    return false;
  }

  resetKeys()
  {
    // Clear modifier states:
    this._modifierState.SHIFT = 0;
    this._modifierState.CONTROL = 0;
    this._modifierState.ALT = 0;
  }

  updateModifierState(event)
  {
    this._modifierState.CONTROL = event.ctrlKey ? 1 : 0;
    this._modifierState.SHIFT = event.shiftKey ? 1 : 0;
    this._modifierState.ALT = event.altKey ? 1 : 0;
  }

  handleGesture(event)
  {
    if (event === this._startEvent)
    return false;

    switch (event.type) {

      case "drag3start":
        if (this._viewerApi.navigation.isActionEnabled('fov')) {
          this._startEvent = event;
          this._fovActive = true;
        }
        break;

      case "drag3move":
        break;

      case "drag3end":
        this._fovActive = false;
        break;

      case "rotatestart":
        if (this._viewerApi.navigation.isActionEnabled('roll')) {
          this._startEvent = event;
          this._rollActive = true;
        }
        break;

      case "rotatemove":
        break;

      case "rotateend":
        this._rollActive = false;
        break;
    }
    return false;
  }

  handleKeyDown(event, keyCode)
  {
    this.updateModifierState(event);

    switch (keyCode) {

      // Do we need to consume these events?
      case this._keys.SHIFT:this._modifierState.SHIFT = 1;break;
      case this._keys.CONTROL:this._modifierState.CONTROL = 1;break;
      case this._keys.ALT:this._modifierState.ALT = 1;break;
    }
    return false;
  }

  handleKeyUp(event, keyCode)
  {
    this.updateModifierState(event);

    switch (keyCode) {

      // Do we need to consume these events?
      case this._keys.SHIFT:this._modifierState.SHIFT = 0;break;
      case this._keys.CONTROL:this._modifierState.CONTROL = 0;break;
      case this._keys.ALT:this._modifierState.ALT = 0;break;
    }
    return false;
  }

  handleButtonDown(event, button)
  {
    this.updateModifierState(event);
    return false;
  }

  handleButtonUp(event, button)
  {
    this.updateModifierState(event);
    return false;
  }

  handleMouseMove(event)
  {
    this.updateModifierState(event);
    return false;
  }

  handleBlur(event)
  {
    // Reset things when we lose focus...
    this.resetKeys();
    return false;
  }

}